"use client";

import {useState} from "react";
import {Swiper, SwiperSlide} from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import HomeCard from "@/src/components/main-site/home/custom-mui/home-card/home-card";
import SectionHeader from "@/src/components/main-site/home/section-header/section-header";
import CategoryFilter from "@/src/components/main-site/home/journals-section/category-filter/category-filter";
import JournalCard from "@/src/components/main-site/home/slider/journal-card/journal-card";
import {Navigation, Pagination} from 'swiper/modules';

export default function JournalsSection({journals}: { journals: any[] }) {
    const [activeCategory, setActiveCategory] = useState("all");
    const categories: string[] = Array.from(new Set(journals.flatMap(journal => journal.categories || []).map(category => category?.trim()).filter(Boolean)));
    const filteredJournals = activeCategory === "all"
        ? journals
        : journals.filter((journal) => journal.categories && journal.categories.includes(activeCategory));

    return (
        <section id="journals" style={{padding: "1rem 0"}}>
            <HomeCard id="journal-container">
                <SectionHeader
                    title="Explore Our Journals"
                    subtitle="Discover a world of cutting-edge research and insights – explore our complete list of journals today and stay at the forefront of your field!"
                />
                <CategoryFilter
                    categories={categories}
                    activeCategory={activeCategory}
                    onCategoryChange={setActiveCategory}
                />
                <Swiper
                    modules={[Navigation, Pagination]}
                    navigation
                    pagination={{clickable: true}}
                    spaceBetween={20}
                    slidesPerView={1}
                    slidesPerGroup={4}
                    breakpoints={{
                        640: {slidesPerView: 1},
                        768: {slidesPerView: 2},
                        1024: {slidesPerView: 3},
                        1280: {slidesPerView: 4},
                    }}
                >
                    {filteredJournals.map((journal) => (
                        <SwiperSlide key={journal.id}>
                            <JournalCard journal={journal}/>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </HomeCard>
        </section>
    );
}
